import { Component, OnInit, ViewChild } from '@angular/core';
import { ElectService } from '../service/elect.service';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-allvoter',
  templateUrl: './allvoter.component.html',
  styleUrls: ['./allvoter.component.css']
})
export class AllvoterComponent implements OnInit {

	data: any;

  constructor(
  	private elsrv: ElectService,   
              public router: Router,
              private route: ActivatedRoute

  	) { }

  ngOnInit(): void {
 		this.elsrv.getAllofVoter().subscribe(data =>{
 			this.data = data;

	    });
  }

}